module.exports = __webpack_public_path__ + "static/vscode-225fbbe09689a4a3219ae1e00fe2280b.png";